import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { infos } from './infos.reducer';
import { guilds } from './guilds.reducer';
import { devices } from './devices.reducer';
import { servers } from './servers.reducer';
import { settings } from './settings.reducer';
import { rLink } from './rLink.reducer';
import { payments } from './payments.reducer';
import { map } from './map.reducer';
import { admin } from './admin.reducer';

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    infos,
    guilds,
    devices,
    servers,
    settings,
    rLink,
    payments,
    map,
    admin
  });

export default rootReducer;